<template>
  <div class="container" ref="container">
    <!-- 已登录状态 -->
    <div class="recommend flex" v-if="isLogin">

      <div class="recommendLeft flex1">

        <!-- 人才库推荐入口 -->
        <div class="recommend-entry-wrapper">
           
          <div class="recommend-entry-item" data-growing-container v-for="(item, index) in recommendEntryMap" :data-growing-idx="index + 10" :key="index" @click="switchTab(item)">
            <div class="recommend-item-content">
              <div class="entry-item-top">
              <div class="entry-item-info">
                <div class="entry-item-title-box">
                  <h3 class="entry-item-title">{{ item.title }}</h3>
                  <span class="entry-item-subtitle">{{ item.subtitle }}</span>
                </div>
                <span class="entry-item-count">+{{ item.count }}</span>
              </div>
              <img :src="item.imgSrc" alt="" class="entry-item-icon">
            </div>

            <div class="entry-item-bottom">
              <p class="entry-item-desc">{{ item.description }}</p>
              <span v-if="index == 1" class="entry-item-update">每天{{ item.updateTime }}更新</span>
            </div>
            </div>
          

          </div>

        </div>
        <!-- 筛选 -->
        <div class="title-container" :class="{'title-fixed': titleFixedState}">
          <span class="title" v-if="jobTypeIsOnline">每日推荐</span>
          <span class="title" v-else>优选简历</span>
          <div v-if="jobTypeIsOnline" class="tab-container cursor_p" :class="{'hove-control': hoverControl}">
            <div class="tab">
              <span>{{ jobRecommend.job_post }}</span>
              <span class="iconfont iconxuanxiang-shouqi"/>
            </div>
            <div class="pa bg_fff resetScrollBar job-type-list">
              <div class="item cursor_p f_14 ellipsis" v-for="(item, index) in jobTypeList" :key="index"
                   :class="{'active': item.recruit_info && item.recruit_info.token === jobRecommend.token}" @click="changeActive(item)">
                {{ item.recruit_info.job_post }}
                <div class="job_tags">
                  <!-- <img class="pr hot-job" src="https://files.wondercv.com/b-pc/fire.png" alt="" v-if="hotJobProfessionIds[item.recruit_info.profession_id]"> -->
                  <img class="pr hot-job" src="https://files.wondercv.com/b-pc/fire.png" alt="">
                  <span v-if="item.recruit_info.status === 'draft'">未发布</span>
                </div>
              </div>
              <!-- <div class="recruitInfos" v-if="!jobTypeIsOnline">
                <div class="tip">你没有在线职位哦~</div>
                <div class="btn" @click="toRecruitInfos">去发布</div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="noJobsTips" v-if="!jobTypeIsOnline && jobTypeList.length===0">
          <span class="iconfont el-icon-s-opportunity"></span>
          <p class="noJobsWords">当前暂无在线职位，发布职位后可获取专属精准推荐人才</p>
          <p class="toSendJobs" @click="toRecruitInfos">立即发布</p>
        </div>
        <div class="noJobsTips" v-if="jobTypeIsOnline && jobTypeList.length > 0 && jobTypeList[0].recruit_info.status==='draft'">
          <span class="iconfont el-icon-s-opportunity"></span>
          <p class="noJobsWords">当前暂无在线职位，发布职位后可获取专属人才推荐</p>
          <p class="toSendJobs" @click="toRecruitInfos">立即发布</p>
        </div>

        <!-- 职位列表 -->
        <div class="recommendList">
          <!-- <none-data title="当前暂无在线职位，快去发布职位吧~" v-if="jobTypeList.length === 1">
            <div class="to-job" slot="content" @click="toRecruitInfos">去发职位</div>
          </none-data> -->
          <none-data title="该职位下暂无推荐简历哦~" v-if="getRecommendResume.list && getRecommendResume.list[0].rec_resumes" />
          <!-- 职位列表 -->
          <skeleton :skeletonType="'resumeList'" v-if="jobRecommendLoading"></skeleton>
          <recommend-list v-if="jobTypeIsOnline === true" :jobRecommend="jobRecommend" :jobInfo="jobInfo" :jobTypeIsOnline="jobTypeIsOnline"/>
          <talentList v-else-if="jobTypeIsOnline === false" :isLoading="false" @getDetail="getDetail" :jobTypeIsOnline="jobTypeIsOnline"/>
          
        </div>

      </div>
    </div>

    <!-- 未登录状态 列表展示 -->
    <div class="recommend flex" v-else>
      <!-- 左侧筛选列表 -->
      <div class="recommendLeft flex1">
        <div class="flex-c">
          <div class="name f_20 color_40 font_w_b flex1">简历推荐</div>
        </div>

        <div class="recommendList">
          <!-- 职位列表 -->
          <recommendCard :demoData="demoData" @customClick="handlerToLogin('/talent/recommend')"/>
        </div>

        <div class="login-wrapper bg_fff flex-c" @click="handlerToLogin('/talent/recommend')">
          <p class="f_16"><a href="javascript:;" class="color_blue">登录</a>后即可查看更多优质简历</p>
        </div>

      </div>
    </div>


    <div class="page-end" v-if="recommendPageEnding && isLogin">没有更多数据啦，换个在线职位试试哦~</div>
    <div class="listMoreEndTips text_center pr f_14 color_cf" v-if="(listOptions.total_count>0 && resumeListObj.searchList.length && jobTypeIsOnline === false)">
      <p class="pr">已经到最底部了</p>
    </div>
    <resume-detail-box ref="resumeDetailBox" @getDetail="getDetail" :notfindResume="notfindResume"  @hideDetails="hideDetails" :favoritesId="favoritesId" v-if="showDetail"/>

      <!-- 完善信息弹层 -->
      <userinfo-tips @confirmToRecruitInfos="hideDetails" />
  </div>
</template>

<script>
import actions from '@/actions'
import demoData from '../../search/data'
import recommendCard from '@/components/searchList/cvCard'
import recommendList from './components/recommend-list/Index'
import noneData from './components/none-data/Index'
import {checkUserState, get_tUser, toLogin} from '@/utils/utils';
import {mapMutations, mapActions, mapState} from "vuex";
import  hotJobPro  from '@/assets/js/constant.js'
import talentList from './components/talenteList/Index.vue'
import ResumeDetailBox from '@/components/resumeDetailBox/index'
import userinfoTips from '@/components/block/userinfoTips'
import skeleton from '@/components/skeletonDiagram/index.vue'
export default {
  name: "talentRecommendNew",
  components: {
    recommendList,
    noneData,
    recommendCard,
    talentList,
    ResumeDetailBox,
    'userinfo-tips':userinfoTips,
    skeleton
  },
  data() {
    return {
      jobInfo:{},
      hotJobProfessionIds:hotJobPro.hotJobProfessionIds,
      demoData: demoData,   // 假职位
      jobRecommend: {    // 当前选中的在线职位
        // token: '',
        // job_post: '职位筛选'
      },
      hoverControl: true,  // hover 在线职位选择下拉控制
      jobRecommendLoading: true,   // 简历列表 loading
      jobTypeList: [    // 所有在线职位
        // {
          // recruit_info: {
          //   token: '',
          //   job_post: '全部职位'
          // }
        // }
      ],
      userJWT: {},
      isLogin: true,
      total_count: 0,   // 分页数据总数
      dataParam: {    // 推荐列表接口参数
        page: 1,
        page_size: 10,
        token: ''
      },
      titleFixedState: false, // 吸顶控制
      recommendEntryMap: [
        // 0新入库人才
        {
          title: '新入库人才',
          subtitle: '回复率高',
          count: 0,
          imgSrc: 'https://files.wondercv.com/pc/hr/recommendnew.png',
          description: '候选人更活跃邀约回复更快',
          updateTime: '8:00',
          routerName: '/talent/recommend/new'
        },
        // 1优选人才
        {
          title: '优选人才',
          subtitle: '高质量人才',
          count: 0,
          imgSrc: 'https://files.wondercv.com/pc/hr/recommendoptimization.png',
          description: '人工挑选背景优秀的好简历，先到先得',
          updateTime: '8:00',
          routerName: '/talent/recommend/optimization'
        },
        // 2订阅人才
        {
          title: '订阅人才',
          subtitle: '精准推荐',
          count: 0,
          imgSrc: 'https://files.wondercv.com/pc/hr/recommendsubscription.png',
          description: '根据订阅条件，为你推荐最新简历',
          updateTime: '8:00',
          routerName: '/talent/recommend/subscription'
        }
      ],
      jobTypeIsOnline:true, //是否有在线职位或草稿职位
      isLoading:true,
      showDetail:false,
      favoritesId:'',
      notfindResume:false,//是否未找到简历
    }
  },
  async created() {
    this.updateRoutePageName(this.$route.name);
    // 获取每日推荐简历数量
    this.userJWT = get_tUser();
    // 是否登录
    if (!this.userJWT.t) {
      this.isLogin = false
    } else if (!this.userJWT.h_t) {
      window.location.href = `${window.location.origin}/talent/binduser?link_to=${encodeURIComponent(encodeURIComponent(window.location.href))}`
    }
    if (this.isLogin) {
      this.getRecommendCount()
      await this.getMyOnlineJob()
      if(this.jobTypeIsOnline === true) {
        if(this.jobTypeList[0].status==='draft') this.dataParam.status='draft'
        this.getRecommendResume({data: this.dataParam, refresh: true}).then(() => {
          this.jobRecommendLoading = false
        }).catch((err) => {
          this.$message.error(err)
        })
      }else if(this.jobTypeIsOnline === false){
        this.getNoJobList()
      }
      
    }
  },
  watch: {
    windowScrollTop: {
      handler: function (val, oldVal){
        if (this.jobTypeList && this.jobTypeList.length === 0) {
          return
        }
        // // body高度 - 浏览器窗口高度
        let clientHeight = this.$refs.container.clientHeight
        // pageIsLoading : 是否正在加载
        // recommendPageEnding : 分页是否已经是最后一页
        if (clientHeight - this.windowInnerHeight - val < 200 && !this.pageIsLoading && !this.recommendPageEnding && this.isLogin) {
          let queryLoading =  this.$message({
            message: '正在加载...',
            iconClass:'el-icon-loading',
            duration:0,
          });
          this.updateRecommendPageLoading(true)
          this.dataParam.page = this.dataParam.page + 1
          this.getRecommendResume({data: this.dataParam}).catch((err) => {
            this.$message.error(err)
          }).finally(() => {
            queryLoading.close()
          })
        }
        this.titleFixedState = val > 90;
      }
    }
  },
  computed: {
    ...mapState('block',['bodyClientHeight', 'windowScrollTop', 'windowInnerHeight']),
    ...mapState('resumeDetails',['recommendPageEnding', 'pageIsLoading','resumeListObj','listOptions'])
  },
  methods: {
    ...mapMutations('resumeDetails',['updateNewRecommendJob', 'updateRoutePageName', 'updateRecommendPageLoading','updateRecommend','updateResumeListObj','updateListOptions','updateSearchListObj','updateResumeDetail','updateResumeDetailToken','updateDownloadResumeInfo', 'updateShowDetailFlag', 'updateSearchResumeBasic']),
    ...mapActions('resumeDetails',['getMyPosition', 'getRecommendResume']),
    // 根据发布的在线职位推荐简历
    // async getRecommend() {
    //   try {
    //     let res = await actions.resumes.getRecommend(this.dataParam)
    //     console.log(res,"=================>res")
    //   } catch (e) {
    //
    //   }
    // },

    switchTab (item) {
      this.$router.push({path: item.routerName})
    },
    async getJobTypeList(){
      const draftArr = []
      let res = await actions.recruit_infos.get_recruit_infos_list({status: "publish"});
      if(res.code===1000){
        for(let i=0;i<res.data.jobs.length;i++){
          res.data.jobs[i].recruit_info = res.data.jobs[i]
          if(res.data.jobs[i].recruit_info.status === 'draft') draftArr.push(res.data.jobs[i])
          if(res.data.jobs[i].recruit_info.status === 'publish') this.jobTypeList.push(res.data.jobs[i])
        }
        this.jobTypeList = this.jobTypeList.concat(draftArr)
        //如果有在线职位 jobTypeIsOnline 为 true
        if(this.jobTypeList.map(a => a.status).indexOf('publish') > -1 ) this.jobTypeIsOnline = true
        else if(this.jobTypeList.map(a => a.status).indexOf('draft') > -1 ) this.jobTypeIsOnline = true
        else this.jobTypeIsOnline = false
        let { token,status } = this.$route.query
        // 有多个在线职位时默认选中第一个在线职位进行简历推荐
        this.jobRecommend = res.data.jobs[0].recruit_info.status === "offline" ? {token: '',job_post: '职位筛选'} : res.data.jobs[0].recruit_info
        this.jobInfo = res.data.jobs[0].recruit_info.status === "offline" ? {} : res.data.jobs[0].recruit_info
        if (token) {
          // 其他页面携带token跳转过来
          let setJob = res.data.jobs.filter(item => item.recruit_info.token === token)
          this.jobRecommend = setJob[0].recruit_info
          if(status === 'draft') this.dataParam.status = 'draft'
          this.jobInfo = setJob[0].recruit_info
        } else {
          // 有多个在线职位时默认选中第一个在线职位进行简历推荐
          this.jobRecommend = res.data.jobs[0].recruit_info.status === "offline" ? {token: '',job_post: '职位筛选'} : res.data.jobs[0].recruit_info
        }
        this.updateNewRecommendJob(this.jobInfo)
        this.dataParam.token = this.jobRecommend.token
      }
    },
    // 获取每日推荐简历数量
    async getRecommendCount () {

      try {
        let res = await actions.resumes.get_recommend_count()
        if (res.code === 1000) {
          // 新入库简历数量	
          this.recommendEntryMap[0].count = res.data.resume_new_count
          // 优选简历数量
          this.recommendEntryMap[1].count = res.data.resume_optimization_count
          // 订阅简历数量	
          this.recommendEntryMap[2].count = res.data.resume_subscription_count
        }
      } catch (e) {
        console.log(e)
      }

    },
    // 返回顶部
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },

    handlerToLogin (url) {
      toLogin(`${window.location.origin}${url}`)
    },
    // 获取我发布的在线职位
    async getMyOnlineJob() {
      try {
        let { token } = this.$route.query
        let setJob = {}
        console.log(token)
        let res = await actions.resume_permissions.recruitment()
        let {code, data: {recruit_infos}, message} = res
        if (code === 1000) {
          // 没有在线职位时需要关闭loading
          // if (!recruit_infos) {
          //   console.log(recruit_infos,'recruit_infos')
          //   // this.jobRecommendLoading = false
          // } else {
          //   // 有多个在线职位时默认选中第一个在线职位进行简历推荐
          //   this.jobRecommend = recruit_infos[0].recruit_info
          //   this.jobInfo = recruit_infos[0].recruit_info
          //   if (token) {
          //     // 其他页面携带token跳转过来
          //     setJob = recruit_infos.filter(item => item.recruit_info.token === token)
          //     this.jobRecommend = setJob[0].recruit_info
          //   } else {
          //     // 有多个在线职位时默认选中第一个在线职位进行简历推荐
          //     this.jobRecommend = recruit_infos[0].recruit_info
          //   }
          //   this.dataParam.token = this.jobRecommend.token
          // }
          // recruit_infos.forEach(item => {
          //   this.jobTypeList.push(item)
          // })       
          await this.getJobTypeList()
        } else {
          this.$message.error(message)
        }
      } catch (e) {

      }
    },
    // 切换jobType
    changeActive(obj) {
      // hover 出现下拉框逻辑控制，点击之后关闭下拉框
      this.hoverControl = false
      setTimeout(() => {
        this.hoverControl = true
      },1000)
      if (this.token === obj.recruit_info.token) {
        return
      }
      // 修改职位筛选 label
      if (obj.recruit_info.job_post === '全部职位') {
        this.jobRecommend = {
          token: '',
          job_post: '职位筛选'
        }
      } else {
        this.jobRecommend = obj.recruit_info
      }
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      let queryLoading =  this.$message({
        message: '正在加载...',
        iconClass:'el-icon-loading',
        duration:0,
      });
      this.jobInfo = obj
      this.updateNewRecommendJob(obj)
      this.dataParam = {
        token: this.jobRecommend.token,
        page: 1,
        page_size: 10
      }
      if(obj.status === 'draft'){
        this.dataParam.status = 'draft'
      }else{
        this.dataParam.status = ''
      }
      this.getRecommendResume({data: {...this.dataParam}, refresh: true}).catch((err) => {
        this.$message.error(err);
        this.$message.error(err);
      }).finally(() => {
        queryLoading.close()
      })
    },
    // 去发职位
    toRecruitInfos(){
      if(!this.userJWT.t){
        //增加登录之后自动跳转到相应页面
        toLogin(`${window.location.origin}/talent/jobedit/create`)
      }else{
        window.location.href = '/talent/jobedit/create'
      }
    },
    async getNoJobList(){
      // actions.resumes.newGetResumes(queryData).then(res=>{
      await actions.resumes.get_optimization_resume().then(res=>{
        this.jobRecommendLoading = false;
        if(res.code ===1000){
          let resumeListObj = {}
          resumeListObj.searchList = res.data.resumes;
          this.updateResumeListObj({key:'searchList', value: resumeListObj.searchList});
          //更新当前路由名字
          this.updateRoutePageName('talentSearchList');
          //列表数据同不到vuex
          this.updateListOptions({
            page: this.dataParam.page,
            page_size: this.dataParam.page_size,
            total_count: res.data.total_count,
            keyword_seg: res.data.keyword_seg || []
          });
        }
      })
    },
    async getDetail(options){
      // 将列表简历的基本信息存入vuex
      this.updateSearchResumeBasic(options.item)
      this.updateDownloadResumeInfo(options.item)
      console.log('推荐');
      //更新搜索参数到vuex
      this.updateSearchListObj({
        ...this.searchListObj,
        keyword_hit: options.keyword_hit || [], //列表搜索关键词数据
        keyword_seg:[], //列表分词数据
      })

      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1:()=>{
          // this.$router.replace({name:'talentSearchIndex'});
          // return false;
        },
        callback2:()=>{
          //列表回到第一页，刷新数据
          this.pageChange(1);
          return false;
        },
      });
      let user = get_tUser();
      if(user.h_t){
        //获取职位列表
        this.getMyPosition({job_id: this.job_id});
      }
      // 显示骨架图loading
      this.updateShowDetailFlag(false)
      this.showDetail = true;
      actions.resume_permissions.v2resumedetails({token: options.token}).then(res=>{
        if(res.code === 80139 || res.code === 80120 || res.code === 1000 || res.code === 80121){
          // 如果是翻页，需要同步当前第几个
          if(options.type=== 'prev' || options.type==='next' || options.isNextPage){
            let resumeIndex = options.type==='next' || options.isNextPage ? this.listOptions.resumeIndex+1 : this.listOptions.resumeIndex-1;
            //同步分页数据
            this.updateListOptions({
              ...this.listOptions,
              resumeIndex: resumeIndex,
            });
          }
        }
        if(res.code === 80139 || res.code === 80120 || res.code === 80121){
          this.notfindResume = true;
          //显示弹层
          // this.showDetail = true;
          this.updateShowDetailFlag(true)
          return false;
        }
        this.notfindResume = false;
        if(res.code === 1000){
          //数据同步到vuex中
          this.updateResumeDetail(res.data);
          this.$refs.resumeDetailBox && this.$refs.resumeDetailBox.highlightFunc()
          //简历详情相关url 及 参数，用作收藏等交互 
          this.updateResumeDetailToken(options.token);
          // this.encodeURI({token: options.token});

          //显示弹层
          // this.showDetail = true;
          this.updateShowDetailFlag(true)

        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //隐藏详情
    hideDetails(){
      this.showDetail = false;
      //重置详情的token相关数据
      this.updateResumeDetailToken('');
      document.body.style.position = 'initial'
      document.body.style.overflow = 'initial'
    },
  }
}
</script>

<style lang="scss" scoped>
@import './Index.scss';
</style>
